module.exports = __webpack_public_path__ + "static/media/plantSeven.10526f59.jpg";